/* FAR Boot Screen v1.7 modular */

      (function () {
        var root = document.getElementById('far-boot-preview');
        if (!root || root.dataset.farBootInitialized === 'true') return;
        root.dataset.farBootInitialized = 'true';

        var overlay = root.querySelector('[data-far-boot-overlay]');
        var skipButton = root.querySelector('[data-far-boot-skip]');
        var duration = parseInt(root.getAttribute('data-far-boot-duration'), 10) || 6000;
        var showOnce = root.getAttribute('data-far-boot-show-once') === 'true';
        var storageScope = root.getAttribute('data-far-boot-storage') || 'session';
        var storageKey = root.getAttribute('data-far-boot-key') || 'far-print-shop-boot-v1-1';
        var finished = false;
        var finishTimer = null;
        var previousHtmlOverflow = '';
        var previousBodyOverflow = '';
        var scrollLocked = false;

        function buildDottedLogo() {
          var canvas = root.querySelector('[data-far-dot-logo]');
          var source = root.querySelector('[data-far-dot-source]');
          if (!canvas || !source || !canvas.getContext) return;

          var ctx = canvas.getContext('2d', { alpha: true });
          var offscreen = document.createElement('canvas');
          var offCtx = offscreen.getContext('2d', { willReadFrequently: true });
          var points = [];
          var frameId = null;
          var startTime = null;
          var drawWidth = 0;
          var drawHeight = 0;
          var dpr = 1;

          function readCss(name, fallback) {
            var value = getComputedStyle(root).getPropertyValue(name).trim();
            return value || fallback;
          }

          function makePoints() {
            var rect = canvas.getBoundingClientRect();
            if (!rect.width || !rect.height || !source.naturalWidth || !source.naturalHeight) return false;

            dpr = Math.min(window.devicePixelRatio || 1, 2);
            drawWidth = Math.max(1, Math.round(rect.width * dpr));
            drawHeight = Math.max(1, Math.round(rect.height * dpr));
            canvas.width = drawWidth;
            canvas.height = drawHeight;
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.clearRect(0, 0, drawWidth, drawHeight);

            offscreen.width = drawWidth;
            offscreen.height = drawHeight;
            offCtx.clearRect(0, 0, drawWidth, drawHeight);
            offCtx.drawImage(source, 0, 0, drawWidth, drawHeight);

            var pixels;
            try {
              pixels = offCtx.getImageData(0, 0, drawWidth, drawHeight).data;
            } catch (error) {
              root.classList.add('is-dot-fallback');
              return false;
            }

            points = [];
            var shortSide = Math.min(drawWidth, drawHeight);
            var gap = Math.max(5, Math.round(shortSide / 86));
            var radius = Math.max(1.35, gap * 0.31);
            var dotColor = '#ffffff';

            for (var y = Math.floor(gap * 0.5); y < drawHeight; y += gap) {
              for (var x = Math.floor(gap * 0.5); x < drawWidth; x += gap) {
                var i = ((y * drawWidth) + x) * 4;
                var alpha = pixels[i + 3];
                var r = pixels[i];
                var g = pixels[i + 1];
                var b = pixels[i + 2];
                var darkness = 255 - ((r + g + b) / 3);
                if (alpha > 24 && (alpha > 160 || darkness > 22)) {
                  var sweep = (x / drawWidth) * 0.55 + (1 - y / drawHeight) * 0.31;
                  var noise = Math.abs(Math.sin((x * 12.9898 + y * 78.233) * 0.00231)) * 0.14;
                  points.push({
                    x: x,
                    y: y,
                    r: radius * (0.82 + Math.min(alpha / 255, 1) * 0.36),
                    delay: Math.min(0.92, sweep + noise),
                    color: dotColor
                  });
                }
              }
            }
            return points.length > 0;
          }

          function render(timestamp) {
            if (!startTime) startTime = timestamp;
            var total = Math.max(3200, duration * 0.72);
            var progress = Math.min(1, (timestamp - startTime) / total);
            ctx.clearRect(0, 0, drawWidth, drawHeight);

            for (var i = 0; i < points.length; i += 1) {
              var point = points[i];
              var local = (progress - point.delay * 0.72) / 0.24;
              if (local <= 0) continue;
              if (local > 1) local = 1;
              var ease = 1 - Math.pow(1 - local, 3);
              ctx.globalAlpha = Math.min(1, ease * 1.1);
              ctx.fillStyle = point.color;
              ctx.beginPath();
              ctx.arc(point.x, point.y, point.r * (0.3 + ease * 0.7), 0, Math.PI * 2);
              ctx.fill();
            }

            ctx.globalAlpha = 1;
            if (progress < 1 && !finished) {
              frameId = window.requestAnimationFrame(render);
            }
          }

          function startDots() {
            if (!makePoints()) return;
            if (frameId) window.cancelAnimationFrame(frameId);
            startTime = null;
            frameId = window.requestAnimationFrame(render);
          }

          if (source.complete && source.naturalWidth) {
            startDots();
          } else {
            source.addEventListener('load', startDots, { once: true });
            source.addEventListener('error', function () {
              root.classList.add('is-dot-fallback');
            }, { once: true });
          }

          var resizeTimer = null;
          window.addEventListener('resize', function () {
            if (finished) return;
            if (resizeTimer) window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(startDots, 120);
          });
        }

        function getStorage() {
          try {
            return storageScope === 'local' ? window.localStorage : window.sessionStorage;
          } catch (error) {
            return null;
          }
        }

        function markSeen() {
          var storage = getStorage();
          if (!showOnce || !storage) return;
          try {
            storage.setItem(storageKey, '1');
          } catch (error) {}
        }

function hasSeenBoot() {
  var storage = getStorage();

  if (!showOnce || !storage) return false;

  var isReload = false;

  try {
    var navEntries = window.performance && window.performance.getEntriesByType
      ? window.performance.getEntriesByType('navigation')
      : [];

    if (navEntries && navEntries.length) {
      isReload = navEntries[0].type === 'reload';
    } else if (window.performance && window.performance.navigation) {
      isReload = window.performance.navigation.type === 1;
    }
  } catch (error) {
    isReload = false;
  }

  if (isReload) {
    try {
      storage.removeItem(storageKey);
    } catch (error) {}

    return false;
  }

  try {
    return storage.getItem(storageKey) === '1';
  } catch (error) {
    return false;
  }
}

        function signalFinished() {
          try {
            window.dispatchEvent(new CustomEvent('far:boot-finished', {
              detail: { sectionId: 'preview' }
            }));
          } catch (error) {}
        }

        function lockScroll() {
          previousHtmlOverflow = document.documentElement.style.overflow;
          previousBodyOverflow = document.body ? document.body.style.overflow : '';
          document.documentElement.style.overflow = 'hidden';
          if (document.body) document.body.style.overflow = 'hidden';
          scrollLocked = true;
        }

        function restoreScroll() {
          if (!scrollLocked) return;
          document.documentElement.style.overflow = previousHtmlOverflow;
          if (document.body) document.body.style.overflow = previousBodyOverflow;
          scrollLocked = false;
        }

        function removeNow(shouldMarkSeen) {
          if (finishTimer) window.clearTimeout(finishTimer);
          if (shouldMarkSeen) markSeen();
          restoreScroll();
          if (root && root.parentNode) root.parentNode.removeChild(root);
          signalFinished();
        }

        function finishBoot() {
          if (finished) return;
          finished = true;
          root.classList.add('is-exiting');
          markSeen();
          restoreScroll();
          document.removeEventListener('keydown', handleKeydown);
          if (finishTimer) window.clearTimeout(finishTimer);

          window.setTimeout(function () {
            if (root && root.parentNode) root.parentNode.removeChild(root);
            signalFinished();
          }, 430);
        }

        function handleKeydown(event) {
          if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            finishBoot();
          }
        }

        if (!overlay || hasSeenBoot()) {
          removeNow(false);
          return;
        }

        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          removeNow(true);
          return;
        }

        lockScroll();
        buildDottedLogo();
        window.requestAnimationFrame(function () {
          root.classList.add('is-running');
          if (skipButton && skipButton.focus) {
            try {
              skipButton.focus({ preventScroll: true });
            } catch (error) {
              skipButton.focus();
            }
          }
        });

        finishTimer = window.setTimeout(finishBoot, duration);

        overlay.addEventListener('click', finishBoot);
        if (skipButton) skipButton.addEventListener('click', finishBoot);
        document.addEventListener('keydown', handleKeydown);
      })();
